import { Forward02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

interface SkippedReasonViewProps {
  title: string;
  message: string;
}

export const SkippedReasonView = ({
  title,
  message
}: SkippedReasonViewProps) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div className="rounded-full bg-alpha-20 size-16 flex items-center justify-center">
          <HugeiconsIcon
            icon={Forward02Icon}
            size={24}
            className="text-content-1000"
          />
        </div>
        <div className="flex flex-col items-center gap-2">
          <p className="text-center text-base font-bold text-content-1000">
            {title}
          </p>
          <p className="text-center text-sm font-medium text-content-300">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};
